///<amd-module name="typeahead/core/message/FlightOriginPopulationMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class FlightOriginPopulationMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "flight_origin_population";
    }

    private populatedOrigin: string;
    private latitude: string;
    private longitude: string;

    constructor(populatedOrigin: string, latitude: string, longitude: string) {
        this.populatedOrigin = populatedOrigin;
        this.latitude = latitude;
        this.longitude = longitude;
    }

    public getTopic(): string {
        return FlightOriginPopulationMessage.getTopic();
    }

    public getPopulatedOrigin(): string {
        return this.populatedOrigin;
    }

    public getLatitude(): string {
        return this.latitude;
    }

    public getLongitude(): string {
        return this.longitude;
    }
}
